import type { ListBuilderList } from '../../../types';

/**
 * Pending Quote list configuration
 * Shows requests with lines pending quote
 */
export const pendingQuoteList: ListBuilderList = {
	id: 'default-sourcing-requests-pending-quote',
	cacheTTL: 300000,
	name: 'Pending Quote',
	type: 'default',
	active: true,
	sortOrder: 6,
	filterRules: {
		sourcingRequestAssignedUser: {
			defaultValue: [{ id: 'ME', label: 'Me' }],
			lockedIf: {
				type: 'group',
				joiner: 'AND',
				negated: false,
				children: [
					{ type: 'rule', action: 'sourcing_requests:view:any', negated: true },
				],
			},
			hiddenIf: {
				type: 'group',
				joiner: 'AND',
				negated: false,
				children: [
					{ type: 'rule', action: 'sourcing_requests:view:any', negated: true },
				],
			},
		},
		sourcingRequestLineStatus: {
			defaultValue: [{ id: 'pending', label: 'Pending' }],
			locked: true,
			hidden: true,
		},
	},
	inheritsFrom: 'default-sourcing-requests-all',
};
